
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { ActionMethod } from "vuex";

@Component({
  name: "Chat",
})
export default class Chat extends Vue {
  @Prop({ default: "" }) readonly uriChat!: string;

  @Prop({ default: "" }) readonly uriWhats!: string;

  @Prop({ default: true }) readonly isChatEnabled!: boolean;

  @Prop({ default: true }) readonly isWhatsEnabled!: boolean;

  @Action getTokenChat!: ActionMethod;

  @Watch("open")
  async onOpenChanged() {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.open ? "ajuda:abrir" : "ajuda:fechar",
      });
    }
  }

  @Watch("chat")
  async onChatChanged() {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.chat ? "chat:abrir" : "chat:fechar",
      });
    }
  }

  open = false;

  chat = false;

  uriFrame = this.uriChat;

  ready = false;

  async checkLogin(): Promise<void> {
    let err = false;
    const win = window as any;
    const ret = await this.getTokenChat().catch((error) => {
      err = true;
      const parseError = JSON.parse(error);
      if (this.$gtm.enabled()) {
        win.dataLayer.push({
          event: "event",
          eventCategory:
            this.$route.fullPath === "/"
              ? "claro-flex:home"
              : "claro-flex:checkout",
          eventAction: "callback:chat",
          eventLabel: "erro:".concat(
            !parseError.message ? parseError.code : parseError.message
          ),
        });
      }
    });
    if (!err) {
      this.uriFrame = this.uriChat
        .concat("?token=")
        .concat(ret.token)
        .concat("&origem=naologado&appOrigem=Flex");
      if (localStorage.getItem("x-customer-id")) {
        this.uriFrame = this.uriChat
          .concat("?token=")
          .concat(ret.token)
          .concat("&origem=logado&appOrigem=Flex&nome=")
          .concat(localStorage.getItem("nome")!)
          .concat("&cpf=")
          .concat(localStorage.getItem("cpf")!)
          .concat("&email=")
          .concat(localStorage.getItem("email")!);

        if (localStorage.getItem("msisdn")) {
          this.uriFrame = this.uriFrame
            .concat("&telefone=")
            .concat(localStorage.getItem("msisdn")!);
        }
      }
    }
  }

  openWhats(): void {
    const win = window as any;
    if (this.$gtm.enabled()) {
      win.dataLayer.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: "ajuda:whatsapp",
      });
    }
    window.open(this.uriWhats, "_blank");
  }

  async created() {
    let err = false;
    const win = window as any;
    const ret = await this.getTokenChat().catch((error) => {
      err = true;
      const parseError = JSON.parse(error);
      if (this.$gtm.enabled()) {
        win.dataLayer.push({
          event: "event",
          eventCategory:
            this.$route.fullPath === "/"
              ? "claro-flex:home"
              : "claro-flex:checkout",
          eventAction: "callback:chat",
          eventLabel: "erro:".concat(
            !parseError.message ? parseError.code : parseError.message
          ),
        });
      }
    });
    if (!err) {
      this.uriFrame = this.uriChat
        .concat("?token=")
        .concat(ret.token)
        .concat("&origem=naologado&appOrigem=Flex");
      if (localStorage.getItem("x-customer-id")) {
        this.uriFrame = this.uriChat
          .concat("?token=")
          .concat(ret.token)
          .concat("&origem=logado&appOrigem=Flex&nome=")
          .concat(localStorage.getItem("nome")!)
          .concat("&cpf=")
          .concat(localStorage.getItem("cpf")!)
          .concat("&email=")
          .concat(localStorage.getItem("email")!);

        if (localStorage.getItem("msisdn")) {
          this.uriFrame = this.uriFrame
            .concat("&telefone=")
            .concat(localStorage.getItem("msisdn")!);
        }
      }
      this.ready = true;
      if (this.$gtm.enabled()) {
        win.dataLayer.push({
          event: "event",
          eventCategory:
            this.$route.fullPath === "/"
              ? "claro-flex:home"
              : "claro-flex:checkout",
          eventAction: "callback:chat",
          eventLabel: "sucesso",
        });
      }
    }
  }
}
